import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeywordSynonyms } from '@/lib/hooks/use-keyword-synonyms';
import { useKeywords } from '@/lib/hooks/use-keywords';

interface SearchBarProps {
  placeholder?: string;
}

export function SearchBar({
  placeholder = 'Zoek meditaties, muziek, natuurgeluiden...',
}: SearchBarProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const { findKeywordBySynonym } = useKeywordSynonyms();
  const { keywords } = useKeywords([]);

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;

    // Check if the search query matches any keyword synonyms
    const keywordId = await findKeywordBySynonym(searchTerm);

    if (keywordId) {
      // If we found a matching keyword via synonym, find the keyword name
      const matchedKeyword = keywords.find((k) => k.id === keywordId);
      if (matchedKeyword) {
        navigate(
          `/search?keywords=${keywordId}&name=${encodeURIComponent(matchedKeyword.name)}`,
        );
        return;
      }
    }

    // If no synonym match, proceed with regular search
    navigate(`/search?query=${encodeURIComponent(searchTerm)}`);
  };

  return (
    <form onSubmit={handleSearch} className="relative w-full max-w-xl">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        className="pl-10 w-full rounded-full"
        placeholder={placeholder}
        type="search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </form>
  );
}
